module.exports = __webpack_public_path__ + "img/green-marker.b3d5f23e.svg";